/**
 * Created by amirb on 7/19/15.
 */
define(function (require) {

    var BaseApiService = require('web-agent-utils/BaseApiService');

    lpTag.AuthenticationChat = function (baseUrl) {
        this.applicationType = "AuthenticationChat";
        var agentSessionVisitApiResource, getSingleAdditionalUrl;

        if (baseUrl) {
            var resourceDomainUrl = baseUrl.substring(0, baseUrl.indexOf('.json')) + '/';
            getSingleAdditionalUrl = "participantExtendedInfo/{participantId}?v=1";
            agentSessionVisitApiResource = BaseApiService.createInstance({domainUrl: resourceDomainUrl, postmessagePath: "/postmessage", serviceName: this.applicationType});
        }

        function _createRequest(reqObj, participantId) {
            reqObj.method = 'GET';
            reqObj.additionalUrl = getSingleAdditionalUrl.replace("{participantId}", participantId + "");
            reqObj.callingFunction = 'getAuthChat';
            return reqObj;
        }

        this.getRequest = function (reqObj, visitorId, participantId) {
            reqObj = _createRequest(reqObj, participantId);
            var fullRequest = agentSessionVisitApiResource.createBasicRequest(reqObj);
            fullRequest.polling = true;
            return fullRequest;
        };

        this.getAuthChat = function (reqObj, visitorId, participantId) {
            reqObj = _createRequest(reqObj, participantId);
            reqObj.callingFunction = 'getAuthChat';
            agentSessionVisitApiResource.sendRequest(reqObj);
        };

        this.moveToOldAuthApi = function () {
            getSingleAdditionalUrl = "participantInfo/{participantId}?v=1";
        };

        this.isNewApi = function () {
            return getSingleAdditionalUrl !== "participantInfo/{participantId}?v=1";
        };
    };

    return lpTag.AuthenticationChat;

});
